import { render, staticRenderFns } from "./DashboardPayrollQuickStat.vue?vue&type=template&id=e82887ae"
import script from "./DashboardPayrollQuickStat.vue?vue&type=script&lang=js"
export * from "./DashboardPayrollQuickStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports